let env = {
    endpoint_backend: process.env.VUE_APP_API_URL,
    endpoint_frontend: process.env.VUE_APP_URL,
}

export default env
